export default "__VITE_ASSET__CGjChqFq__"